import { Box, Button, Grid, styled, TextField } from '@mui/material';

export const Container = styled(Box)`
  margin: 2.5rem;
`;

export const InputBox = styled(TextField)`
  width: 12.5rem;
  height: 0.125rem;
`;

export const SubmitButton = styled(Button)`
  margin-left: 1.875rem;
  margin-top: 0.3125rem;
`;

export const StatusText = styled(Grid)`
  margin-top: 1.25rem;
  font-weight: bold;
`;
